import $ from 'jquery';
let currentPage = 1;

$('.knowledge-center-section').on('click', '#load-older-posts', function(e) {
  e.preventDefault();
  currentPage++;

  $.ajax({
    type: 'POST',
    url: ajax.ajaxurl,
    data: {
      action: 'load_more_posts',
      nonce: ajax.nonce,
      paged: currentPage
    },
    success: function (res) {
      const data = JSON.parse(res)
      const maxPosts = data.max;

      $('.knowledge-center-section__list').append(data.html);
      
      const postsLength = $('.knowledge-center-section__list').children().length;

      if ( maxPosts === postsLength ) {
        $('#load-older-posts').hide();
      }
    }
  });
});